import React, { useEffect, useState, useRef, useMemo } from "react";

const Cursor = () => {
  const [pointer, setPointer] = useState({
    x: 0.5 * window.innerWidth,
    y: 0.5 * window.innerHeight,
  });
  const params = useMemo(
    () => ({
      pointsNumber: 40,
      widthFactor: 0.2,
      spring: 0.43,
      friction: 0.5,
    }),
    []
  );
  const trail = useRef(
    new Array(params.pointsNumber)
      .fill(0)
      .map(() => ({ x: pointer.x, y: pointer.y, dx: 0, dy: 0 }))
  );
  const svgRef = useRef(null);
  const requestRef = useRef();

  useEffect(() => {
    const svg = svgRef.current;
    if (svg) {
      for (let i = 0; i < params.pointsNumber; i++) {
        const path = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "path"
        );
        const startHue = 180;
        const hueIncrement = 360 / params.pointsNumber;
        const hue = (startHue + i * hueIncrement) % 360;
        const strokeColor = `hsl(${hue}, 100%, 70%)`;

        path.setAttribute("id", `t${i}`);
        path.setAttribute("stroke", strokeColor);
        path.setAttribute(
          "stroke-width",
          params.widthFactor * (params.pointsNumber - i)
        );
        path.setAttribute("fill", "none");

        svg.appendChild(path);
      }
    }

    const handleMouseMove = (event) => {
      setPointer({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, [params.pointsNumber, params.widthFactor]);

  useEffect(() => {
    const update = () => {
      const newTrail = trail.current.map((point, index, arr) => {
        const prevPoint = index === 0 ? pointer : arr[index - 1];
        const spring = index === 0 ? 0.4 * params.spring : params.spring;
        point.dx += (prevPoint.x - point.x) * spring;
        point.dy += (prevPoint.y - point.y) * spring;
        point.dx *= params.friction;
        point.dy *= params.friction;

        return {
          ...point,
          x: point.x + point.dx,
          y: point.y + point.dy,
        };
      });
      trail.current = newTrail;

      trail.current.forEach((point, index) => {
        const path = document.getElementById(`t${index}`);
        if (path) {
          const prevPoint = index === 0 ? pointer : trail.current[index - 1];
          const pathString = `M ${prevPoint.x} ${prevPoint.y} L ${point.x} ${point.y}`;
          path.setAttribute("d", pathString);
        }
      });

      requestRef.current = requestAnimationFrame(update);
    };

    requestRef.current = requestAnimationFrame(update);
    return () => {
      cancelAnimationFrame(requestRef.current);
    };
  }, [pointer, params]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    >
      <svg
        ref={svgRef}
        width={window.innerWidth}
        height={window.innerHeight}
        style={{ position: "absolute" }}
      />
    </div>
  );
};

export default Cursor;
